import { render, staticRenderFns } from "./garageDialog.vue?vue&type=template&id=a5421978"
import script from "./garageDialog.vue?vue&type=script&lang=js"
export * from "./garageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports